import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./fonts/Product-Sans-Regular.ttf";
import "./";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
